import React from "react";
import MainContentCard from "../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import TCListLocalPurchaseOrdersChild from "./TCListLocalPurchaseOrdersChild";

const TCListLocalPurchaseOrders = () => {
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes
        page="TCListLocalPurchaseOrders"
        route="/tc-list-lpo"
      >
        <TCListLocalPurchaseOrdersChild />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default TCListLocalPurchaseOrders;
